import React, { useRef } from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
function Calendar({ initialEvents = [], calendarRef, eventClick, title = "" }) {
  const renderEventContent = (eventInfo) => {
    // console.log(eventInfo);

    return (
      <>
        <p className="text-truncate mb-0" title={eventInfo.event.title}>
          <b>{eventInfo.timeText}</b>
          <br />
          {eventInfo.event.title}
        </p>
      </>
    );
  };
  const eventRender = (info) => {
    const isRecurring = info.event.extendedProps.recurrenceRule != null;

    if (isRecurring) {
      // Check if the event is currently selected
      const isSelected =
        info.view &&
        info.view.calendar.currentData.eventSelection &&
        info.event.id === info.view.calendar.currentData.eventSelection.id;

      // Apply a custom style for recurring events
      info.el.style.backgroundColor = isSelected ? "lightblue" : "lightgray";
      info.el.style.borderColor = isSelected ? "blue" : "gray";
      info.el.style.color = isSelected ? "white" : "black";
    }
  };

  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      headerToolbar={{
        left: "prev,next",
        center: "title",
        right: "timeGridWeek,timeGridDay,dayGridMonth", // user can switch between the two
      }}
      initialEvents={initialEvents}
      // eventContent={eventRender}
      eventClick={eventClick}
      displayEventTime={true}
      editable={true}
      selectable={true}
      // dayMaxEvents={true}
      selectAllow={true}
      // handleCustomRendering={eventRender}
    />
  );
}

export default Calendar;
